module.exports = __webpack_public_path__ + "media/audios/audio_placeholder2-c5870c82a3e376dfb48b9733eaa2f7a8.mp3";